"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchOverrides = void 0;
var _styles = require("@mui/material/styles");
// Allow hover to be 38px instead of 40px

var switchOverrides = {
  MuiSwitch: {
    defaultProps: {
      disableRipple: false
    },
    styleOverrides: {
      root: function root(_ref) {
        var _ref$theme = _ref.theme,
          opacity = _ref$theme.opacity,
          palette = _ref$theme.palette;
        return {
          '& .MuiSwitch-switchBase': {
            color: palette.common.white,
            '&:hover': {
              backgroundColor: (0, _styles.alpha)(palette.action.active, palette.action.hoverOpacity)
            },
            '&.Mui-checked': {
              color: palette.primary.main,
              '&:hover': {
                backgroundColor: (0, _styles.alpha)(palette.primary.main, palette.action.hoverOpacity)
              },
              '&.Mui-disabled': {
                color: palette.primary.light
              },
              '& + .MuiSwitch-track': {
                backgroundColor: palette.primary.main,
                opacity: opacity.switchTrack
              }
            },
            '&.Mui-disabled': {
              color: palette.grey[50],
              '& + .MuiSwitch-track': {
                opacity: opacity.switchTrackDisabled
              }
            }
          },
          '& .MuiSwitch-thumb': {
            boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)' // TODO: move into theme.shadows
          },

          '& .MuiSwitch-track': {
            backgroundColor: palette.common.black,
            opacity: opacity.switchTrack
          }
        };
      }
    }
  }
};
exports.switchOverrides = switchOverrides;